export enum Directions {
  Next = "next",
  Back = "back"
}